import React, { useEffect, useState } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl";
import Footer from "../Component/Footer";
import defaultfullbanner from "../Component/img/event1.jfif"; // Import the default banner image

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart as faStarEmpty,
  faXTwitter,
  faLinkedinIn,
  faFacebookF,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import RatingComp from "../Component/RatingComp";
import EventAgenda from "../Component/EventAgenda";
import FollowEvent from "../Component/FollowEvent";
import PageViewCount from "../Component/PageViewCount";

const Event = () => {
  const { slug } = useParams();

  // State initialization
  const [eventData, setEventData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        const response = await axios.get(`${BASE_URL}event_by_slug/${slug}`);

        // Log the API response for debugging
        console.log("API Response:", response.data);

        setEventData(response.data.event);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching event details", error);
        setLoading(false);
      }
    };

    fetchEventDetails();
  }, [slug]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "2-digit",
    });
  };

  // Handle loading state
  if (loading) {
    return <div>Loading...</div>; // You can replace this with a loading spinner or placeholder
  }

  return (
    <>
      <NavbarVisitor />
      <PageViewCount eventUniqueId={eventData.event_unique_id} />
      <div className="container-fluid">
        <div className="col-md-12">
          <div className="eventcard_container bg-white p-1 bdrds">
            <div>
              <img
                src={
                  eventData?.event_full_banner
                    ? `${IMAGE_URL}/${eventData.event_full_banner}`
                    : defaultfullbanner
                } // Use imported default banner
                className="img-fluid evntfullban"
                alt="Event Banner"
              />
            </div>
          </div>
        </div>

        <div className="container">
          <div className="mt-3">
            <div className="row">
            <div className="col-md-8 text-start">
              <div className="times">
                {formatDate(eventData.event_start_date)} -{" "}
                {formatDate(eventData.event_end_date)}
              </div>
              <div className="ename">{eventData.event_name}</div>

              <div className="text-start cattext mb-2 ">
                {eventData.event_industry.split(", ").map((industry, index) => (
                  <span
                    key={index}
                    className="badge tagcs bg-gradient-primary mx-1"
                  >
                    #{industry}&nbsp;
                  </span>
                ))}
              </div>

              <div className="">
                <img
                  src={
                    eventData.event_image
                      ? `${IMAGE_URL}/${eventData.event_image}`
                      : defaultfullbanner
                  }
                  className="img-fluid imgevnt"
                  alt="Event"
                />
              </div>

              <div>
                <p>
                  {eventData.event_description ||
                    "No description available for this event."}
                </p>
              </div>

              <div className="text-start">
                <h3 className="h3clsss">Share On</h3>
                <div>
                  <span className="tagcs fbbg">
                    <FontAwesomeIcon
                      icon={faFacebookF}
                      className="text-white"
                    />
                  </span>
                  <span className="tagcs whatappbg">
                    <FontAwesomeIcon icon={faWhatsapp} className="text-white" />
                  </span>
                  <span className="tagcs linkedinbg">
                    <FontAwesomeIcon
                      icon={faLinkedinIn}
                      className="text-white"
                    />
                  </span>
                  <span className="tagcs xbg">
                    <FontAwesomeIcon icon={faXTwitter} className="text-white" />
                  </span>
                </div>
              </div>

              <div className="mt-3">
                <h3 className="h3clsss">Timings</h3>
                <p>
                  {new Date(eventData.event_start_date).toLocaleTimeString()} -
                  {new Date(eventData.event_end_date).toLocaleTimeString()}
                </p>

                <h3 className="h3clsss">Event Type</h3>
                <p>{eventData.event_type}</p>

                <h3 className="h3clsss">Venue</h3>
                <p>{eventData.venue_name}</p>

                <h3 className="h3clsss">Frequency</h3>
                <p>{eventData.event_frequency}</p>
              </div>

              <div className="p-3 bg-salt">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="svgorg">
                    <svg viewBox="0 0 40 40" fill="none" className="svgorg">
                      <circle cx="20" cy="20" r="20" fill="#BBC4DB"></circle>
                      <path
                        d="M32.116 35.863C36.908 32.21 40 26.441 40 19.95 40 12.806 36.255 6.537 30.622 3 21.153 3.522 8 8.04 8 13.838c0 3.72 4.614 4.755 9.022 5.745 2.904.651 5.718 1.283 7.068 2.648 1.263 1.278.745 3.5.212 5.79-.902 3.87-1.848 7.928 5.698 7.928.713 0 1.419-.029 2.116-.086z"
                        fill="#5F73A7"
                      ></path>
                    </svg>
                    &nbsp;By <strong>{eventData.event_organiser}</strong>
                  </div>
                  <div>
                    {/* <span className="bg-gradient-primary btnnflow">Follow</span> */}
                  </div>
                </div>
              </div>

              <div className="mt-3">
                <h2 className="h3clsss text-start mb-2">
                  Venue Map & Direction
                </h2>

                <div className="row">
                  <div className="col-md-8">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: (() => {
                          // Check if eventData.venue_map is available
                          if (eventData.venue_map) {
                            // Replace width and height if they exist
                            let updatedMap = eventData.venue_map;

                            // Replace width if present
                            updatedMap = updatedMap.replace(
                              /width="\d+"/,
                              'width="100%"'
                            );

                            // Replace height if present
                            updatedMap = updatedMap.replace(
                              /height="\d+"/,
                              'height="200"'
                            );

                            return updatedMap; // Return the modified string
                          }
                          return ""; // Return an empty string if venue_map is not available
                        })(),
                      }}
                    />
                  </div>

                  <div className="col-md-4 text-start">
                    <p className="reviewcs">
                      <strong>{eventData.venue_name}</strong>
                    </p>
                    <p className="reviewcs11">
                      {eventData.city_name},{eventData.state_name}
                    </p>
                    <p className="reviewcs11">{eventData.country_name}</p>
                  </div>
                </div>

                <div>
                  <RatingComp eventUniqueId={eventData.event_unique_id} />
                  <EventAgenda eventUniqueId={eventData.event_unique_id} />
                </div>
              </div>
            </div>



            <div className="col-md-4">
              <div className="bg-salt p-2">
                <FollowEvent eventUniqueId={eventData.event_unique_id} />
                
              </div>
            </div>



            </div>
            
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Event;
